export const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

// NOTE:
// Currently ACMS is returning the dates as "2024-11-24-12:00",
// while in our static json the dates were introduced as "January 8, 2025 23:59:59",
// this function takes care of refactoring acms date to ISO 8601 format
// e.g: "2024-11-22-12:00" => "2024-11-22T12:00"
// US5905037, revised to be "inclusive" within a given date range.

export const convertToISOString = (dateTimeString, isStart) => {
  const [year, month, day, time] = dateTimeString.split(/[-:]/);
  let adjustedTime = null;
  if (dateTimeString.endsWith('-12:00')) {
    adjustedTime = isStart ? '00:00' : '23:00';
  }
  const timeVal = adjustedTime ? adjustedTime : `${time}:00`;
  const date = `${year}-${month}-${day}T${timeVal}`;
  return date;
};

export const formatLTOOfferButtonText = (offerDates, offerButtonText) => {
  const { isLTO } = offerDates;

  if (!isLTO) {
    return offerButtonText;
  }

  const { offerStartDate, offerEndDate, mockCurrentDate } = offerDates;

  const formatedEndDate = convertToISOString(offerEndDate, false);
  const formatedStartDate = convertToISOString(offerStartDate, true);

  const start = new Date(formatedStartDate);
  const end = new Date(formatedEndDate);
  const todaysDate = mockCurrentDate ? new Date(mockCurrentDate) : new Date();

  const inTimeWindow = todaysDate >= start && todaysDate <= end;
  let updatedOfferButtonText;

  if (inTimeWindow && offerButtonText) {
    const daysLeft = Math.round((end - todaysDate) / MILLISECONDS_IN_DAY);
    if (daysLeft <= 10 && 1 < daysLeft) {
      updatedOfferButtonText = `${offerButtonText} | Expires in ${daysLeft} Days`;
    } else if (daysLeft === 1) {
      updatedOfferButtonText = `${offerButtonText} | Expires in 1 Day`;
    } else if (daysLeft < 1) {
      updatedOfferButtonText = `${offerButtonText} | Expires Today`;
    }
  }

  return updatedOfferButtonText ?? offerButtonText;
};

export const capitalizeButtonText = offerButtonText => {
  if (!offerButtonText) return null;
  return offerButtonText
    .split(' ')
    .map(word => word.charAt(0) + word.slice(1).toLowerCase())
    .join(' ');
};

const remove99 = offerButtonText => {
  if (!offerButtonText) return '';
  return offerButtonText.replace('99', '');
};

export const formatSpecialOfferButtonText = offerButtonText => {
  /*
  DE583225:
  (1) '99' is an indicator which means 'do not elevate'.  confirmed with Shailaja
      that this indicator ONLY applies to GCS-146 which does the verbiage test. 
  (2) if '99' is present, we just need to remove the '99' and return the original text.
  (3) if '99' is NOT present, we return the hard-coded elevated text if the parameter 
      shouldTransform is true and it contains 'special'.
  (4) Otherwise we return the original text.
  */
  const offerText = String(offerButtonText);
  const isNonElevatedSpecialOffer = offerText.includes('99');

  if (isNonElevatedSpecialOffer) {
    return remove99(offerText);
  }

  return offerText;
};
